import selectors from './selectors';

const handleSearchClick = (e) => {
    const { dropdown, input } = selectors.search;

    if (
        document.getElementById(dropdown.slug)
        && !document.getElementById(dropdown.slug).contains(e.target)
        && document.getElementById(dropdown.slug).classList.contains('open')
    ) {
        $(dropdown.id).removeClass('open');
    }
};

export default handleSearchClick;
